import { Analytics } from "@/App/Analytics"
import { MobileFxPage } from "@/App/Fx/MobileFxPage"
import { LiveRates } from "@/App/LiveRates"
import {
  SectionName,
  useIsTornOut,
} from "@/App/TearOutSection/tearOutSection.state"
import { FxTrades } from "@/App/Trades"
import { Resizer } from "@/components/Resizer"
import { useIsDesktop } from "@/utils/useIsDesktop"
import { withSubscribe } from "@/utils/withSubscribe"

export const FxPage = withSubscribe(() => {
  const isDesktop = useIsDesktop()

  const tilesTornOut = useIsTornOut(SectionName.Tiles)
  const blotterTornOut = useIsTornOut(SectionName.FxBlotter)
  const analyticsTornOut = useIsTornOut(SectionName.Analytics)

  if (isDesktop) {
    return (
      <>
        <Resizer defaultHeight={30}>
          {!tilesTornOut && <LiveRates />}
          {!blotterTornOut && <FxTrades />}
        </Resizer>
        {!analyticsTornOut && <Analytics hideBelowMd />}
      </>
    )
  }

  return <MobileFxPage />
})
